import {
    ArrowRightIcon,
    Box,
    Center,
    HStack,
    Pressable,
    Progress,
    ProgressFilledTrack,
    VStack
} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";
import {useHistory} from "react-router-dom";

import useQuickGuide from "./useQuickGuide";

import Paragraph from "@/client/components/Paragraph";
import Text from "@/client/components/Text";

const QuickGuideButton: React.FC = () => {
    const history = useHistory();

    const {numberCompleted, totalSteps} = useQuickGuide();

    const handleClick = useCallback(() => {
        history.push("/quick-guide");
    }, [history]);
    // Don't show if loading or all steps are completed
    if (typeof numberCompleted === "undefined" || numberCompleted === totalSteps) {
        return null;
    }
    return (
        <Pressable
            className="flex flex-row items-center px-2 py-1.5 rounded-md bg-success-600"
            onPress={handleClick}
        >
            <VStack className="mr-3 flex-1" space="sm">
                <HStack className="justify-between items-center">
                    <Paragraph color="white" variant="xs">
                        Quick Start Guide
                    </Paragraph>
                    <HStack className="items-baseline">
                        <Text color="white" variant="xs">
                            {numberCompleted}
                        </Text>
                        <Text color="white" variant="2xs">
                            /{totalSteps}
                        </Text>
                    </HStack>
                </HStack>
                <Box className="w-32">
                    <Progress size="xs" value={(numberCompleted / totalSteps) * 100}>
                        <ProgressFilledTrack className="bg-white" />
                    </Progress>
                </Box>
            </VStack>

            <Center className="p-1 flex-shrink-0 flex-grow-0 rounded-full bg-green-50/20">
                <ArrowRightIcon color="white" size="sm" />
            </Center>
        </Pressable>
    );
};

export default memo(QuickGuideButton);
